import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { SaveService } from "../../../services/save.service";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { CustomDialogService } from "../../../services/customdialog.service";
import { Utils } from "../../../utils/utils";
import { LogsHistoryPopupComponent } from "../logshistorypopup/logshistorypopup.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "remoteresetcommand-list",
    templateUrl: './remoteresetcommand-list.component.html',
    styleUrls: ['./remoteresetcommand-list.component.less'],
    standalone: false
})

export class RemoteResetCommandListComponent implements OnInit {
    @Input('list') list: any[] = [];
    @Output() onReload = new EventEmitter<any>();
    columnsToDisplay = ['Key', 'Description'];

    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

    public dataSource = new MatTableDataSource<any>();

    subscriptionTenant: any;

    constructor(private readonly activatedRoute: ActivatedRoute
        , private readonly router: Router
        , private readonly http: HttpClient
        , private readonly saveService: SaveService
        , public readonly defaults: DefaultValuesService
        , private readonly customDialog: CustomDialogService
        , @Inject('BASE_URL') private readonly baseUrl: string
        , private readonly changeDetectorRefs: ChangeDetectorRef
        , private readonly dialog: MatDialog

    ) {
    }

    openLogsHistory() {
        this.dialog.open(LogsHistoryPopupComponent, {
            width: '80vw',
            maxHeight: '90vh',
            data: { 
                section: 'remoteresetcommand',
                tenantId: this.defaults.tenant,
                controllerTypeId: this.defaults.controllertype.ControllerTypeID
            }
        });
    }

    ngOnChanges() {
        this.dataSource.data = [];
        this.dataSource.data = this.list
    }

    ngOnInit() {
        this.getHeader();
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getHeader()
        });
        this.saveService.addListener(this);
    }
    ngOnDestroy() {
        this.subscriptionTenant.unsubscribe();
    }

    getHeader() {
        if (!this.defaults.isReadonlyUser)
            this.columnsToDisplay = ['Key', 'Description', 'actions'];
        else
            this.columnsToDisplay = ['Key', 'Description'];
    }

    getInput(data: RemoteResetCommand, property: string): any {
        return data[property];
    }

    getDataType(property: string) {
        let result = 'string'
        return result
    }

    changeElement(object: RemoteResetCommand, type: string, value: boolean) {
        object.Enabled = value
        this.http
            .post<any>(
                this.baseUrl + Utils.getRemoteActionAPI() + 'remoteresetcommandconfig', object
            ).subscribe((res) => {
                this.onReload.emit(res);
            }, (error: {
                error: { message: any }
            }) => {
                object.Enabled = !value
                this.customDialog.openDisplayInfoDialog({ title: 'Error', message: error.error.message });
            });
    }
}